import Grid2 from "@mui/material/Unstable_Grid2";
import { PropTypes } from "prop-types";

export const Grid = (props) => {
  const child = props.children;
  return <Grid2 {...props}>{child}</Grid2>;
};

Grid.propTypes = {
  children: PropTypes.any,
};
